import React, { useMemo } from 'react'
import { OneSelect } from '@yy/one-ui'
import { IOneSelectProps } from '@yy/one-ui/lib/OneSelect'
import { withLabelFormItem } from '@common/oneclub/components'
import { useOneclubConfigs } from '@common/oneclub/configuration'
import { getUrlParam } from '@common/oneclub/utils'
/**
 * 注册国家下拉选择
 * @returns
 */
export const CountrySelectNormal: React.FC<IOneSelectProps<any>> = (props) => {
  const app = getUrlParam('app')
  const { country_list } = useOneclubConfigs()

  // os越南只让他选中越南
  const list = useMemo(() => {
    const ret = app === 'osvn' ? country_list?.filter(({ value }) => value === 'VN') : country_list
    return ret.sort((a, b) => (a.label > b.label ? 1 : -1))
  }, [app, country_list])

  return (
    <OneSelect {...props} dropdownClassName="themeBlack">
      {list?.map((item) => (
        <OneSelect.Option value={item.value} key={item.value}>
          {item.label}
        </OneSelect.Option>
      ))}
    </OneSelect>
  )
}

export const CountrySelect = withLabelFormItem<IOneSelectProps<any>>(CountrySelectNormal)
